import React from "react";

class CollapsibleTextViewer extends React.Component {
    constructor(props) {
        super(props);
        this.state = { collapsed: true };
    }

    expand = () => {
        this.setState({ collapsed: false });
    };

    collapse = () => {
        this.setState({ collapsed: true });
    };

    render() {
        let content = null;
        let link = null;

        if (this.state.collapsed) {
            content = this.props.data.substring(0, this.props.maxLength);

            if (this.props.data.length > this.props.maxLength) {
                link = (
                    <span>
                        ...
                        {!this.props.disableExpand && (
                            <>
                                <span>&nbsp;</span>
                                <a role="button" onClick={this.expand}>
                                    Click to see more
                                </a>
                            </>
                        )}
                    </span>
                );
            }
        } else {
            content = this.props.data;
            link = (
                <div>
                    <a role="button" onClick={this.collapse}>
                        Click to see less
                    </a>
                </div>
            );
        }

        return (
            <div>
                {content}
                {link}
            </div>
        );
    }
}

export default CollapsibleTextViewer;
